import React from 'react';

export default function AdminSidebar({ activeView, setActiveView }) {
  const menuItems = [
    { id: 'inquiries', label: '📥 Inquiries', description: 'Form submissions' },
    { id: 'users', label: '👥 User Accounts', description: 'Registered users' },
    { id: 'settings', label: '⚙️ Settings', description: 'Console config' }
  ];

  return (
    <aside className="admin-sidebar">
      <nav className="admin-sidebar-nav">
        {menuItems.map((item) => (
          <button
            key={item.id}
            className={`admin-sidebar-link ${activeView === item.id ? 'active' : ''}`}
            onClick={() => setActiveView(item.id)}
          >
            <span className="admin-sidebar-label">{item.label}</span>
            <span className="admin-sidebar-desc">{item.description}</span>
          </button>
        ))}
      </nav>
      <div className="admin-sidebar-footer">
        <span>System Version 1.0.0</span>
      </div>
    </aside>
  );
}
